export default "__VITE_ASSET__VoYdiSgD__"